module.exports = __webpack_public_path__ + "static/media/dog.87376125.svg";